export const SET_SUBMIT_CONTACT_MESSAGE = 'SET_SUBMIT_CONTACT_MESSAGE';
export const SET_MAIN_CONTACT_SUBMITTING = 'SET_MAIN_CONTACT_SUBMITTING';
export const SET_SHOW_MODAL_LEGAL = 'SET_SHOW_MODAL_LEGAL';
export const SET_LANGUAGE = 'SET_LANGUAGE';